import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { InputField } from '@/components/Form';
import { Button, Col, Row } from 'antd';
import {
  useSendTFNUpdateOTPMutation,
  useUpdateTFNNumberMutation,
} from '../../api/profileAPI';
import { displayError, displaySuccess } from '@/utils/displayMessageUtils';
import { FC } from 'react';

const formSchema = yup.object().shape({
  tfnNumber: yup.string().required('Enter TFN Number'),
});
export type FormType = yup.InferType<typeof formSchema>;

type TFNNumberEditProps = {
  handleTFNSumbit: () => void;
  refetchProfile: () => void;
};
const TFNNumberEdit: FC<TFNNumberEditProps> = ({
  handleTFNSumbit,
  refetchProfile,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormType>({
    resolver: yupResolver(formSchema),
  });
  const [updateTFNNumber, { isLoading }] = useUpdateTFNNumberMutation();

  const [sendTFNUpdateOTP, { isLoading: sendTFNUpdateOTPLoading }] =
    useSendTFNUpdateOTPMutation();

  const onSubmit = async (data: FormType) => {
    sendTFNUpdateOTP({ tfn_number: data.tfnNumber })
      .unwrap()
      .then((res) => {
        displaySuccess(res?.message);
        handleTFNSumbit();
        refetchProfile();
      })
      .catch((err) => {
        console.log(err);
        console.log('This si the error informations');
        displayError(err);
      });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row gutter={30}>
        <Col xs={24}>
          <InputField
            name="tfnNumber"
            control={control}
            label="TFN Number"
            size="large"
            required
            error={errors?.tfnNumber?.message ?? ''}
          />
        </Col>
        <Col xs={24}>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            disabled={isLoading}
            loading={isLoading}
          >
            Submit
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default TFNNumberEdit;
